import { NumberUtils, lodash, ArrayUtils } from "neo-common";
import { Communication } from "neo-games";
import { Configuration } from "../../Components/Configuration";
import { BetManager } from "../../Managers/BetManager";
import { AppContext } from "../../../Common/AppContext";

export class FireBirdPaytable {
    private _logo: HTMLElement;
    private _payoutsElements: Object;
    private _countsElements: Object;
    private _valuesElements: Object;
    private _values: Object;

    constructor() {
        this._payoutsElements = {};
        this._countsElements = {};
        this._valuesElements = {};
        this._values = {};
    }

    initialize(): void {
        this._logo = document.getElementById("paytableLogo");

        let config: Element = Configuration.Configurations["PaytableConfiguration"];

        if (config != null) {
            let next: Element = config.firstElementChild;
            while (next != null) {
                if (next.hasAttribute("Symbol")) {
                    let id: string = next.getAttribute("Symbol");
                    let attrCounts: string = null;
                    let attrValues: string = null;

                    let payoutElement: HTMLElement;
                    payoutElement = document.getElementById("payout-" + id);
                    if (payoutElement != null) {
                        this._payoutsElements["payout-" + id] = payoutElement;
                    }

                    if (id === "1" || id === "2" || id === "3") {
                        id = "1_2_3";
                        payoutElement = document.getElementById("payout-" + id);
                        if (payoutElement != null) {
                            this._payoutsElements["payout-" + id] = payoutElement;
                        }
                    } else if (id === "4" || id === "5") {
                        id = "4_5";
                        payoutElement = document.getElementById("payout-" + id);
                        if (payoutElement != null) {
                            this._payoutsElements["payout-" + id] = payoutElement;
                        }
                    }

                    let i: number;
                    if (next.hasAttribute("Counts")) {
                        attrCounts = next.getAttribute("Counts");
                        let counts: Array<string> = next.getAttribute("Counts").split(";");
                        for (i = 0; i < counts.length; i++) {
                            let countElement: HTMLElement = document.getElementById("count-" + id + "-" + counts[i]);
                            if (countElement != null) {
                                this._countsElements["count-" + id + "-" + counts[i]] = countElement;
                            }
                        }
                    }

                    if (next.hasAttribute("Values")) {
                        attrValues = next.getAttribute("Values");
                        let values: Array<string> = next.getAttribute("Values").split(";");
                        let countsForValues: Array<string> = next.getAttribute("Counts").split(";");
                        for (i = 0; i < values.length; i++) {
                            if (countsForValues[i] != null) {
                                let valueElement: HTMLElement = document.getElementById(
                                    "symbolValue-s" + id + "-" + countsForValues[i],
                                );
                                if (valueElement != null) {
                                    let calculateValue: string;
                                    if (AppContext.gameConfiguration.UseCoins && BetManager.CoinCount != null) {
                                        calculateValue = NumberUtils.multiply(Number(values[i]), BetManager.CoinCount);
                                    } else {
                                        calculateValue = NumberUtils.multiply(Number(values[i]), BetManager.Bet);
                                    }
                                    valueElement.innerHTML = calculateValue;
                                    this._valuesElements["symbolValue-s" + id + "-" + countsForValues[i]] =
                                        valueElement;
                                    this._values["symbolValue-s" + id + "-" + countsForValues[i]] = values[i];
                                }
                            }
                        }
                    }
                }
                next = next.nextElementSibling;
            }
        }
    }

    changeBet(): void {
        this.reset();

        for (let key in this._valuesElements) {
            let calculateValue: string;
            if (this._values[key] != null) {
                let calculateValue: string;
                if (AppContext.gameConfiguration.UseCoins && BetManager.CoinCount != null) {
                    calculateValue = NumberUtils.multiply(this._values[key], BetManager.CoinCount);
                } else {
                    calculateValue = NumberUtils.multiply(this._values[key], BetManager.Bet);
                }
                this._valuesElements[key].innerHTML = calculateValue;
            }
        }
    }

    showWins(wins: Array<Communication.Game.IWin>): void {
        this.reset();

        let payoutIdsMap = lodash.map(wins, (win: Communication.Game.IWin) => win.payoutId).join(";");
        let countsMap = lodash.map(wins, (win: Communication.Game.IWin) => win.count).join(";");
        let payoutIds = ArrayUtils.numberArray(payoutIdsMap);
        let counts = ArrayUtils.numberArray(countsMap);

        if (payoutIdsMap != "") {
            for (let key in this._payoutsElements) {
                this._payoutsElements[key].classList.add("_noWin");
            }
        }

        for (let i: number = 0; i < payoutIds.length; i++) {
            let payoutId = payoutIds[i].toString();
            let count = counts[i];

            if (
                this._payoutsElements["payout-" + payoutId] != null &&
                !this._payoutsElements["payout-" + payoutId].classList.contains("highlight")
            ) {
                this._payoutsElements["payout-" + payoutId].classList.add("highlight");
                this._payoutsElements["payout-" + payoutId].classList.remove("_noWin");
            }

            if (payoutId === "1" || payoutId === "2" || payoutId === "3") {
                payoutId = "1_2_3";
                if (
                    this._payoutsElements["payout-" + payoutId] != null &&
                    !this._payoutsElements["payout-" + payoutId].classList.contains("highlight")
                ) {
                    this._payoutsElements["payout-" + payoutId].classList.add("highlight");
                    this._payoutsElements["payout-" + payoutId].classList.remove("_noWin");
                }
            } else if (payoutId === "4" || payoutId === "5") {
                payoutId = "4_5";
                if (
                    this._payoutsElements["payout-" + payoutId] != null &&
                    !this._payoutsElements["payout-" + payoutId].classList.contains("highlight")
                ) {
                    this._payoutsElements["payout-" + payoutId].classList.add("highlight");
                    this._payoutsElements["payout-" + payoutId].classList.remove("_noWin");
                }
            }

            if (count != null) {
                if (
                    this._countsElements["count-" + payoutId + "-" + count] != null &&
                    !this._countsElements["count-" + payoutId + "-" + count].classList.contains("highlight")
                ) {
                    this._countsElements["count-" + payoutId + "-" + count].classList.add("highlight");
                }
            }
        }
    }

    bounceLogo(): void {
        if (this._logo != null && !this._logo.classList.contains("bounce")) {
            !this._logo.classList.add("bounce");
        }
    }

    reset(): void {
        if (this._logo != null && this._logo.classList.contains("bounce")) {
            !this._logo.classList.remove("bounce");
        }

        var elements = document.getElementsByClassName("highlight");
        while (elements.length > 0) {
            elements[0].classList.remove("highlight");
        }

        var elements = document.getElementsByClassName("_noWin");
        while (elements.length > 0) {
            elements[0].classList.remove("_noWin");
        }
    }

    setFsScene(enabled: boolean): void {
        let paytableHolder = document.getElementById("paytable");

        if (paytableHolder != null) {
            if (enabled) {
                paytableHolder.classList.add("freespins");
            } else {
                paytableHolder.classList.remove("freespins");
            }
        }
    }

    paytableFade(enable: boolean, isFreespin: boolean = false) {
        let root = document.getElementById("paytable");
        root.classList.remove("_fsScene");

        if (enable) {
            if (isFreespin) {
                root.classList.add("_fsScene");
            }
            root.classList.remove("_transition");
        } else {
            root.classList.add("_transition");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/FireBird/FireBirdPaytable.ts
 **/